export function IsMicrosoftWindows() {
	return (navigator && navigator.platform && navigator.platform.startsWith("Win"));
}
